export default __webpack_public_path__ + "static/media/belt_of_ferine_anger.13f12267.jpg";